module.exports = __webpack_public_path__ + "static/media/hero_image.21be1a2d.svg";